import { initializeApp } from 'firebase/app';
import { getAuth, setPersistence, browserLocalPersistence } from 'firebase/auth';
import { getFirestore } from 'firebase/firestore';

const firebaseConfig = {
  apiKey: import.meta.env.VITE_FIREBASE_API_KEY,
  authDomain: import.meta.env.VITE_FIREBASE_AUTH_DOMAIN,
  projectId: import.meta.env.VITE_FIREBASE_PROJECT_ID,
  storageBucket: import.meta.env.VITE_FIREBASE_STORAGE_BUCKET,
  messagingSenderId: import.meta.env.VITE_FIREBASE_MESSAGING_SENDER_ID,
  appId: import.meta.env.VITE_FIREBASE_APP_ID,
};

const app = initializeApp(firebaseConfig);

export const auth = getAuth(app);
export const db = getFirestore(app);
export default app;

// In E2E test mode, switch Firebase Auth from IndexedDB to localStorage persistence.
// Playwright's storageState only captures localStorage/cookies — not IndexedDB — so
// without this the saved auth state is empty and tests get redirected to /login.
// Safe: import.meta.env.MODE is 'production' during `npm run build`, so this block
// is tree-shaken out of every production bundle.
if (import.meta.env.MODE !== 'production' && import.meta.env.VITE_E2E_MODE === 'true') {
  setPersistence(auth, browserLocalPersistence);
}